import { combineReducers } from 'redux';
import chatReducer from './chat-reducer';

export const makeRootReducer = asyncReducers => {
  let attrs = Object.assign({}, asyncReducers);
  attrs['chat'] = chatReducer;
  return combineReducers(attrs);
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/store/reducers.js